export default "<p>\r\n  esg-checklist-score works!\r\n</p>\r\n"